import { dateToShow } from '@/helpers/dates'
import moment from 'moment'
import reduceWithSeparator from '@/helpers/reduce-with-separator'
import { get, uniq, isEmpty } from 'lodash'

const prepareShow = schedule => {
  schedule.time = moment(schedule.date).format('HH:mm')
  schedule.date = dateToShow(schedule.date)

  return schedule
}

const prepareSchedulesByDate = schedules => {
  if (!isEmpty(schedules)) {
    const dates = uniq(schedules.map(item => moment(item.date).format('DD/MM')))
    const newSchedules = schedules.map(prepareSchedule)

    const items = {}

    dates.map(date => {
      items[date] = newSchedules.filter(schedule => date === schedule.date)
    })

    return items
  }
}

const prepareSchedule = schedule => {
  schedule.time = moment(schedule.date).format('HH:mm')
  schedule.date = moment(schedule.date).format('DD/MM')

  return schedule
}

export default {
  doProfessionalProfile () {
    console.log('segundo modal')
  },

  doStart () {
    this.$resource.get(this.scheduleId + '/details')
      .then(({data}) => {
        this.schedule = prepareShow(data)
        this.patient = get(data, 'patient', {})
        this.professional = get(data, 'agenda.professional', {})
        this.covenant = get(data, 'covenant.name', 'Particular')
        this.covenants = get(data, 'agenda.covenants', [])
        this.specialities = reduceWithSeparator(get(data, 'agenda.specialities', []))

        this.addresses = get(data, 'agenda.next_schedules_by_agendas', []).map(address => {
          address.schedules = prepareSchedulesByDate(get(address, 'next_schedules', []))

          delete address.next_schedules

          return address
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/components/event-details/resources/methods.js